import { render, staticRenderFns } from "./initiatePayroll.vue?vue&type=template&id=99abb15c&scoped=true"
import script from "./initiatePayroll.vue?vue&type=script&lang=js"
export * from "./initiatePayroll.vue?vue&type=script&lang=js"
import style0 from "./initiatePayroll.vue?vue&type=style&index=0&id=99abb15c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99abb15c",
  null
  
)

export default component.exports